import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from '@angular/forms';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { WorkerFormService } from '../../data/worker-form.service';

export function hrNumberUniquenessValidator(
  workerFormService: WorkerFormService,
  workerId: number,
  shouldRun: () => boolean
): AsyncValidatorFn {
  return (control) => {
    if (!shouldRun()) return of(null);
    const value = control.value?.trim();
    if (!value) return of(null);

    return workerFormService
      .isHrNumberDuplicated(value, control.parent?.get('institutionId')?.value, workerId)
      .pipe(
        map(isDup => (isDup ? { hrNumberDuplicate: true } : null)),
        catchError(() => of({ hrNumberValidationError: true }))
      );
  };
}

export function hrNumberFormatValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value?.trim()) {
      return null;
    }

    const value = control.value;
    const validPattern = /^[a-zA-Z0-9.\-_/]+$/;

    if (!validPattern.test(value)) {
      return { hrNumberInvalidFormat: true };
    }

    return null;
  };
}